module.exports = [
  'chrome 87',
  'chrome 86',
  'chrome 85',
  'chrome 84',
  'chrome 83',
  'chrome 81',
  'chrome 80',
  'chrome 79',
  'chrome 78',
  'chrome 77',
  'chrome 76',
  'chrome 75',
  'chrome 74',
  'chrome 73',
  'chrome 72',
  'edge 87',
  'edge 86',
  'edge 85',
  'edge 84',
  'edge 83',
  'edge 18',
  'firefox 83',
  'firefox 82',
  'firefox 81',
  'firefox 80',
  'firefox 79',
  'firefox 78',
  'firefox 77',
  'firefox 76',
  'firefox 75',
  'firefox 74',
  'firefox 73',
  'firefox 72',
  'firefox 71',
  'ios_saf 14.0-14.2',
  'ios_saf 13.0-13.1',
  'ios_saf 12.0-12.1',
  'ios_saf 11.0-11.2',
  'safari 14',
  'safari 13.1',
  'safari 13',
  'safari 12.1',
  'safari 12',
  'safari 11.1',
  'samsung 11.1-11.2',
];
